/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import CryptoJS from 'crypto-js'

export const encrypt = (
  data: any,
  force = false,
  frotistaId?: string,
): string => {
  if (typeof data === 'string' && !force) {
    return data
  }

  if (!data || data === '' || typeof data === 'undefined' || data === null) {
    return data
  }

  const normalizedData: any =
    typeof data === 'object' || Array.isArray(data)
      ? JSON.stringify(data)
      : data

  const secretKey = `${process.env.REACT_APP_SECRET_KEY}${frotistaId ?? ''}`
  const retorno = CryptoJS.AES.encrypt(normalizedData, secretKey).toString()

  return retorno
}

export const decrypt = (data: any, frotistaId?: string): any => {
  const secretKey = `${process.env.REACT_APP_SECRET_KEY}${frotistaId ?? ''}`

  const decrypted: string = CryptoJS.AES.decrypt(data, secretKey).toString(
    CryptoJS.enc.Utf8,
  )

  if (Number(decrypted) || Number(decrypted) >= 0 || Number(decrypted) <= 0) {
    return Number(decrypted)
  }
  try {
    return JSON.parse(decrypted)
  } catch (e) {
    return decrypted
  }
}

export const encryptOnlyWithKey = (data: any): string => {
  return encrypt(data)
}
export const decryptOnlyWithKey = (data: any): any => {
  return decrypt(data)
}
